import React from 'react';
import Rossetti from '../components/Rossetti';

const FamilyTreePage = () => {
  return (
    <div className="page-container">
      <Rossetti />
    </div>
  );
};

export default FamilyTreePage;